module.exports = __webpack_public_path__ + "img/download-on-apple-store.c32ab2d2.png";